const BROWSER_VIEWABLE_TYPES = new Set(['application/pdf', 'text/plain', 'text/csv']);

const OBJECT_URL_LIFETIME_MS = 60_000;

const baseContentType = (contentType: string): string =>
  contentType.split(';')[0].trim().toLowerCase();

export const isBrowserViewable = (contentType: string): boolean =>
  BROWSER_VIEWABLE_TYPES.has(baseContentType(contentType));

const inlineContentType = (contentType: string): string => {
  const base = baseContentType(contentType);
  return base.startsWith('text/') ? `${base};charset=utf-8` : base;
};

export const openAttachmentInNewTab = async (url: string, contentType: string): Promise<void> => {
  const tab = window.open('', '_blank');

  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error(`HTTP ${response.status}`);

    const blob = await response.blob();
    const objectUrl = URL.createObjectURL(
      new Blob([blob], { type: inlineContentType(contentType) }),
    );

    if (tab) tab.location.href = objectUrl;
    else window.open(objectUrl, '_blank');

    window.setTimeout(() => URL.revokeObjectURL(objectUrl), OBJECT_URL_LIFETIME_MS);
  } catch (error) {
    tab?.close();
    throw error;
  }
};
